import React from 'react'

export default function Help() {
    return (
        <div>
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_393_377)">
                    <path d="M22 3.66667C32.109 3.66667 40.3333 11.891 40.3333 22C40.3333 32.109 32.109 40.3333 22 40.3333C11.891 40.3333 3.66667 32.109 3.66667 22C3.66667 11.891 11.891 3.66667 22 3.66667ZM22 0C9.8505 0 0 9.8505 0 22C0 34.1495 9.8505 44 22 44C34.1495 44 44 34.1495 44 22C44 9.8505 34.1495 0 22 0ZM24.2917 31.1667C24.2917 32.4317 23.2668 33.4583 22 33.4583C20.7368 33.4583 19.7083 32.4317 19.7083 31.1667C19.7083 29.9017 20.7368 28.875 22 28.875C23.2668 28.875 24.2917 29.9017 24.2917 31.1667ZM26.8455 12.837C25.7308 11.7077 24.068 11.0862 22.1687 11.0862C18.172 11.0862 15.587 13.9278 15.587 18.3278H19.2738C19.2738 15.6035 20.7937 14.6373 22.0935 14.6373C23.2558 14.6373 24.4897 15.4092 24.5942 16.885C24.7078 18.4378 23.8792 19.2262 22.8305 20.2235C20.2418 22.6857 20.1942 23.8773 20.2052 26.5815H23.881C23.8572 25.3642 23.936 24.376 25.5952 22.5885C26.8363 21.2502 28.38 19.5855 28.4112 17.0482C28.4313 15.3542 27.8905 13.8967 26.8455 12.837Z" fill="black" />
                </g>
                <defs>
                    <clipPath id="clip0_393_377">
                        <rect width="44" height="44" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        </div>
    )
}
